import React from 'react';

const formatAddressForDisplay = (address) => {
  const {
    line1, line2, city, state, zipCode,
  } = address;
  let l1 = '';
  let l2 = '';
  let l3 = '';

  if (line1 && line1.trim().length > 0) {
    l1 = line1.trim();
  }
  if (line2 && line2.trim().length > 0) {
    l2 = line2.trim();
  }
  if (city && city.trim().length > 0) {
    l3 += city.trim();
  }
  if (state && state.trim().length > 0) {
    l3 = `${l3} ${state.trim()}`;
  }
  if (zipCode && zipCode.trim().length > 0) {
    l3 = `${l3} ${zipCode.trim()}`;
  }

  return (
    <div className="address">
      <span>
        <span>{`${l1} `}</span>
        {l2.length > 0 && <span>{`${l2} `}</span>}
      </span>{' '}
      <span>{l3}</span>
    </div>
  );
};

export default formatAddressForDisplay;
